import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { preloadAdminAnnouncementBanner } from '@confluence/admin-announcement-banner/entry-points/preloadAdminAnnouncementBanner.ts';
import { preloadStorageEnforcementBanner } from '@confluence/storage-enforcement/entry-points/preloadStorageEnforcementBanner.ts';

export const preloadBanners = async (): Promise<unknown> => {
	const { edition } = getPreloaderFnContext();

	const upperCaseEdition = edition?.toUpperCase() || '';
	if (upperCaseEdition === 'PREMIUM' || upperCaseEdition === 'STANDARD') {
		return preloadAdminAnnouncementBanner();
	} else if (upperCaseEdition === 'FREE') {
		return preloadStorageEnforcementBanner();
	}
};
